module.exports = __webpack_public_path__ + "img/loginTitle.7ab0abc5.png";